import { AddSalesDataForm } from './AddSalesDataForm';
export default AddSalesDataForm;
